import React from 'react'
import AIonCampusWideURL from '../../assets/images/AIonCampus-wide.png';
import AIonCampusMobileURL from '../../assets/images/AIonCampus-mobile.png';

const WideImg = () => {
  return (
    <div className='w-screen px-4 pt-6 pb-12 md:px-8 xl:px-[8vw] md:pt-6 md:pb-20 bg-brand-black'>
        <img src={AIonCampusWideURL} className="hidden sm:block md:rounded-md" alt="AI on campus Wide Image" />
        <img src={AIonCampusMobileURL} className="rounded-md sm:hidden" alt="AI on campus Wide Image Mobile" />
    </div>
  )
}

export default WideImg